import { render } from "./password.vue?vue&type=template&id=a045fc24&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"

import "../../resources/css/settings.scss?vue&type=style&index=0&id=a045fc24&lang=scss&scoped=true&external"
import "./password.vue?vue&type=style&index=1&id=a045fc24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a045fc24"]])

export default __exports__